import * as d3 from "d3";
import { image } from "d3";

export const addFloorPlan = {
  methods: {
    addFloorPlan(link) {
      let that = this
      return new Promise((resolve,_) => {
        d3.svg(link).then(function (xml) {

          d3.select(that.$refs['floor-plan']).node().appendChild(xml.documentElement)

          that.svgFloorPlanContainer = d3.select(that.$refs['floor-plan'])

          // .style("fill", "rgba(0,0,0,0.7)")
          that.svgFloorPlan = that.svgFloorPlanContainer.selectAll("path[id*='apartment_']")
            .style("opacity", "0.3")
            .style("fill", "rgba(0,0,0,0)")
            .style("pointer-events", "all")
            .attr('selected', false)
            .attr('zanyato', true)
            .on("mouseenter", that.mouseOverFloorPlan)
            .on("mouseleave", that.mouseOutFloorPlan)
            .on('mousedown', that.clickOnTheFloorPlan)


            that.selectedFloorAvailableApartments.forEach(apartment => {
              d3.selectAll("#" + 'apartment_' + apartment.number_on_the_floor)
              .attr('zanyato', false)
              .attr('svobodno', true)
              .style('opacity', '0.3')
              .style('cursor', 'pointer')
              .attr('selected', true)
            })
            d3.select("#" + 'apartment_' + that.apartment.number_on_the_floor)
              .style("fill", "#CF5607")
              .style('opacity', '0.3')
              .style('cursor', 'pointer')
          if (that.selectedApartment) {
            that.svgFloorPlanContainer.selectAll("path[id='apartment_" + that.selectedApartment.number_on_the_floor + "']")
              .attr('selected', true)
              .style('opacity', '0.3')
          }
        })
        resolve(true)
      })

    }
  }
};
